import "./custom.css";
import "react-toastify/dist/ReactToastify.css";

import * as React from "react";

import { CarStop } from "./components/CarStop";
import { Control } from "./components/Control";
import { GeoArea } from "./components/GeoArea";
import Layout from "./components/Layout";
import { Main } from "./components/Main";
import { MenuBottom } from "./components/MenuBottom";
import { Route } from "react-router";
import { ToastContainer } from "react-toastify";

export default () => (
  <>
    <ToastContainer
      bodyClassName={() => "myToastClass"}
      position="bottom-center"
      autoClose={3000}
      hideProgressBar={true}
      rtl={true}
    />

    <Layout>
      <Route path="/main" component={Main} />
      <Route exact path="/" component={Main} />
      <Route exact path="/GeoArea" component={GeoArea} />
      <Route exact path="/CarStop" component={CarStop} />
      <Route exact path="/Control" component={Control} />
    </Layout>
    {/*<MenuBottom />*/}
  </>
);
